export default "__VITE_ASSET__B5XLEXb2__"